// extracted by mini-css-extract-plugin
module.exports = {"title":"Transfer_title__1F0hv","option":"Transfer_option__38USa","container":"Transfer_container__2SUWJ"};